module.exports = __webpack_public_path__ + "img/rank13.d1e2e18b.png";